import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import withMixpanel, { PEOPLE_DELETED, SCREEN_VIEW_PEOPLE_ALL } from 'utils/mixpanel'
import { compose, withHandlers, withStateHandlers, lifecycle } from 'recompose'

import * as toastModule from 'modules/toast'
import * as peopleModule from 'modules/people'
import * as popoverModule from 'modules/popover'
import * as userActions from 'actions/userActions'
import * as routeActions from 'actions/routeActions'
import * as organisationModule from 'modules/organisation'

import { isEqual, getPaginationObject } from 'utils/misc'

export default compose(
  withMixpanel,
  connect(
    (state) => {
      return {
        user: idx(state, _ => _.user),
        users: idx(state, _ => _.people.approved),
        tableLoading: idx(state, _ => _.people.loading),
        organisation: idx(state, _ => _.organisation.selected),
        organisationCode: idx(state, _ => _.organisation.selected.code),
        organisationCodeHasLoaded: idx(state, _ => _.progress.getOrganisationCode.hasLoaded),
      }
    },
    (dispatch) => {
      const actions = {
        ...userActions,
        ...toastModule,
        ...routeActions,
        ...peopleModule,
        ...popoverModule,
        ...organisationModule
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  withStateHandlers(
    () => ({
      selectedPeople: [],
      filters: {
        search: [{ key: 'fullName', value: null }],
        filter: [{ key: 'role', value: null }, { key: 'approved', value: true }],
        pagination: {
          offset: 0, limit: 8
        },
        loaded: true,
      }
    }),
    {
      onPageChange: state => (offset) => {
        return getPaginationObject(state, { offset }, false)
      },
      setPagination: state => ({ count }) => {
        return getPaginationObject(state, { count }, true)
      },
      setState: state => changedValues => ({
        ...state,
        ...changedValues
      }),
      setFilters: state => newFilters => ({
        ...state,
        filters: {
          ...state.filters,
          ...newFilters,
          loaded: false,
        }
      }),
    }
  ),
  withHandlers({
    handleGroupDelete: ({
      track, actions, organisation, user, selectedPeople, setState, filters, setPagination
    }) => () => {
      actions.hideToast()
      const isYou = selectedPeople.indexOf(user.id) > -1

      if (isYou) {
        actions.showPopover(popoverModule.DELETE_ADMIN_BLOCKED, {
          hideCloseButton: true,
          title: 'Oops',
          message: "Looks like you've tried to delete your own account. You can only do this on the Settings page. Unselect your account to delete other users from this list.",
          onConfirm: () => {
            actions.hidePopover()
            setState({selectedPeople: []})
          }
        })
      } else {
        actions.showPopover(popoverModule.DELETE_PEOPLE_CONFIRM, {
          hideCloseButton: true,
          peopleCount: selectedPeople.length,
          organisationName: organisation.name,
          onConfirm: () => {
            actions.deletePeople(organisation, selectedPeople, () => {
              track(PEOPLE_DELETED)
              setState({ selectedPeople: [] })
              actions.hidePopover()
              actions.getPeople(organisation, filters, setPagination)
            })
          },
          onClose: () => {
            actions.hidePopover()
            setState({ selectedPeople: [] })
          }
        })
      }
    },
  }),
  // Handlers
  withHandlers({
    onDeactivateClick: ({ organisation, actions }) => () => {
      if (actions.deleteOrganisationCode) {
        actions.deleteOrganisationCode(organisation)
      }
    },
    onGenerateClick: ({ actions }) => () => {
      actions.showPopover(popoverModule.GENERATE_ORG_CODE)
    },
    onSearchChange: ({ setFilters }) => (value) => {
      setFilters({ search: [{ key: 'fullName', value }] })
    },
    onTableSortClick: ({ setFilters }) => (orderBy) => {
      setFilters({ orderBy: [orderBy] })
    },
    onFilterChange: ({ setFilters }) => (value) => {
      setFilters({
        filter: [{ key: 'role', value }, { key: 'approved', value: true }]
      })
    },
    onTableRowClick: ({ actions }) => (user) => {
      actions.viewUserDetails(user)
    },
    onTableSelectableClick: ({ setState, ...state }) => (person) => {
      const selectedPeople = [...state.selectedPeople]
      const userIndex = selectedPeople.indexOf(person.id)

      if (userIndex > -1) {
        selectedPeople.splice(userIndex, 1)
      } else {
        selectedPeople.push(person.id)
      }
      setState({
        selectedPeople,
        bulkSelected: false,
      })
    },
    onCodeCopyClick: props => () => {
      props.actions.showToast(toastModule.SUCCESS_TOAST, 'Copied to clipboard')
    },
    handleSelectedChange: ({
      actions, selectedPeople, handleGroupDelete
    }) => () => {
      actions.showToast(toastModule.ACTION_BUTTON_TOAST, {
        manual: true,
        actionLabel: selectedPeople.length > 1 ? 'Delete selected' : 'Delete',
        label: `${selectedPeople.length} user${selectedPeople.length !== 1 ? 's' : ''} selected`,
        onActionClick: () => handleGroupDelete()
      })
    }
  }),
  lifecycle({
    componentDidMount() {
      const {
        track, actions, organisation, filters, setPagination
      } = this.props

      track(SCREEN_VIEW_PEOPLE_ALL)
      actions.getPeople(organisation, filters, setPagination)
      actions.getOrganisationCode(organisation)
    },
    componentDidUpdate(prevProps) {
      const {
        actions, selectedPeople, handleSelectedChange, filters, organisation, setPagination
      } = this.props

      if (selectedPeople.length !== prevProps.selectedPeople.length) {
        if (selectedPeople.length === 0) {
          actions.hideToast()
        } else {
          handleSelectedChange()
        }
      }
      if (!isEqual(filters, prevProps.filters) && !filters.loaded) {
        actions.getPeople(organisation, filters, setPagination)
      }
    }
  }),
)



// WEBPACK FOOTER //
// ./src/containers/people/PeopleOverview/PeopleOverview.enhancer.js